module.exports = __webpack_public_path__ + "static/media/plusIcon.02229d1a.svg";